import { render, staticRenderFns } from "./ShoppingListBtn.vue?vue&type=template&id=6a57d064&scoped=true"
import script from "./ShoppingListBtn.vue?vue&type=script&lang=js"
export * from "./ShoppingListBtn.vue?vue&type=script&lang=js"
import style0 from "./ShoppingListBtn.vue?vue&type=style&index=0&id=6a57d064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a57d064",
  null
  
)

export default component.exports